var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('router-view')],1),_c('content-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }